import { render, staticRenderFns } from "./UserCompanyEdit.vue?vue&type=template&id=2342486f&"
import script from "./UserCompanyEdit.vue?vue&type=script&lang=js&"
export * from "./UserCompanyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports